  <div class="row">
    <div class="col-md-12">
      <h6>Short Description</h6>
      <p>
        Short Description of the API goes here
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex, dignissimos ut et magni, consequuntur aspernatur dolores, quae neque quam impedit minus eveniet nostrum laudantium excepturi esse dolorem labore sint id magnam eum similique amet. Illum, optio doloremque nam vero delectus minima perferendis, totam perspiciatis quod enim distinctio. Velit, corrupti dolore!
      </p>
      <hr/>

      <app-emailapi></app-emailapi>
      
    </div>
  </div>

